import { BrowserRouter, Routes, Route } from 'react-router-dom';

import RequireAuthentication from './RequireAuthentication';
import RequireAuthorization from './RequireAuthoziration';
import RequireModules from './RequireModules';
import { EModule } from '../enums';

import { RecoverRequestsProvider } from '../contexts/RecoverRequestsContext';
import { CityTaxesProvider } from '../contexts/CityTaxesContext';

import LayoutAdmin from '../components/LayoutAdmin';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Cities from '../pages/Cities';
import NewCity from '../pages/Cities/NewCity';
import EditCity from '../pages/Cities/EditCity';
import Roles from '../pages/Roles';
import NewRole from '../pages/Roles/NewRole';
import EditRole from '../pages/Roles/EditRole';
import PanelUsers from '../pages/PanelUsers';
import EditPanelUser from '../pages/PanelUsers/EditPanelUser';
import NewPanelUser from '../pages/PanelUsers/NewPanelUser';
import FirstAccess from '../pages/FirstAccess';
import AppUsers from '../pages/AppUsers';
import ViewAppUser from '../pages/AppUsers/ViewAppUser';
import InvoicesGroupedByMonth from '../pages/AppUsers/ViewAppUserInvoices/InvoicesGroupedByMonth';
import Giveaways from '../pages/Giveaways';
import NewGiveaway from '../pages/Giveaways/NewGiveaway';
import EditGiveaway from '../pages/Giveaways/EditGiveaway';
import AppUserTickets from '../pages/AppUsers/ViewAppUserTickets/Tickets';
import Tickets from '../pages/Giveaways/Tickets';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import Rewards from '../pages/Rewards';
import NewReward from '../pages/Rewards/NewReward';
import EditReward from '../pages/Rewards/EditReward';
import Categories from '../pages/Categories';
import NewCategory from '../pages/Categories/NewCategory';
import EditCategory from '../pages/Categories/EditCategory';
import RecoverRequests from '../pages/RecoverRequests';
import ViewRecoverRequest from '../pages/RecoverRequests/ViewRecoverRequest';
import ViewAppUserVouchers from '../pages/AppUsers/ViewAppUserVouchers';
import Vouchers from '../pages/Vouchers';
import ViewVoucher from '../pages/Vouchers/ViewVoucher';
import TermsOfUse from '../pages/TermsOfUse';
import GiveawayWinners from '../pages/Giveaways/GiveawayWinners';
import Invoices from '../pages/AppUsers/ViewAppUserInvoices/Invoices';
import TicketsGroupedByGiveaway from '../pages/AppUsers/ViewAppUserTickets/TicketsGroupedByGiveaway';
import CityTaxes from '../pages/CityTaxes';
import ViewCityTax from '../pages/CityTaxes/ViewCityTax';
import HoldGiveaway from '../pages/Giveaways/HoldGiveaway';
import AwardTypes from '../pages/AwardTypes';
import NewAwardType from '../pages/AwardTypes/NewAwardType';
import EditAwardType from '../pages/AwardTypes/EditAwardType';
import RegainAccessDocuments from '../pages/RegainAccessDocuments';
import Unauthorized from '../pages/Unauthorized';
import Messages from '../pages/Messages';
import NewMessage from '../pages/Messages/NewMessage';
import EditMessage from '../pages/Messages/EditMessage';
import CityHasNoModule from '../pages/CityHasNoModule';
import ForgotPassword from '../pages/ForgotPassword';
import RecoveryPassword from '../pages/RecoveryPassword';
import HelpAndSupport from '../pages/HelpAndSupport';
import ViewMessageHelpAndSupport from '../pages/HelpAndSupport/ViewMessageHelpAndSupport';
import SubjectHelpAndSupport from '../pages/SubjectHelpAndSupport';
import NewSubjectHelpAndSupport from '../pages/SubjectHelpAndSupport/NewSubjectHelpAndSupport';
import EditSubjectHelpAndSupport from '../pages/SubjectHelpAndSupport/EditSubjectHelpAndSupport';
import VerifyGiveaway from '../pages/Giveaways/VerifyGiveaway';
import { CityTaxesAutoProvider } from '../contexts/CityTaxesAutoContext';
import CityTaxesAuto from '../pages/CityTaxesAuto';
import AppUsersAuto from '../pages/AppUsersAuto';
import ViewAppUserAuto from '../pages/AppUsersAuto/ViewAppUserAuto';
import GiveawaysAuto from '../pages/GiveawaysAuto';
import VerifyGiveawayAuto from '../pages/GiveawaysAuto/VerifyGiveawayAuto';
import NewGiveawayAuto from '../pages/GiveawaysAuto/NewGiveawayAuto';
import EditGiveawayAuto from '../pages/GiveawaysAuto/EditGiveawayAuto';
import HoldGiveawayAuto from '../pages/GiveawaysAuto/HoldGiveawayAuto';
import GiveawayAutoWinners from '../pages/GiveawaysAuto/GiveawayAutoWinners';
import GiveawayTicketsAuto from '../pages/GiveawaysAuto/GiveawayTicketsAuto';
import CityTaxeAutoImport from '../pages/CityTaxesAuto/CityTaxeAutoImport';
import ViewMessageSupport from '../pages/Support/ViewMessageSupport';
import CityInvoices from '../pages/CityInvoices';
import CityCompanyInvoices from '../pages/CityCompanyInvoices';
import GiveawayParticipants from '../pages/Giveaways/GiveawayParticipants';
import ViewGiveaway from '../pages/Giveaways/ViewGiveaway';
import AccessCode from '../pages/AccessCode';
import ViewGiveawayAuto from '../pages/GiveawaysAuto/ViewGiveawayAuto';
import CityInvoicesAwaiting from '../pages/CityInvoicesAwaiting';
import Notices from '../pages/Notice';
import NewNotice from '../pages/Notice/NewNotice';
import EditNotice from '../pages/Notice/EditNotice';
import SocialInstitutions from '../pages/SocialInstitutions';
import CityInvoicesImport from '../pages/CityInvoicesImport';
import CityPendingInvoices from '../pages/CityPendingInvoices';
import InvoiceDetails from '../pages/InvoiceDetails';
import AccessLogs from '../pages/AccessLog';
import CityInvoicesDuplicated from '../pages/CityInvoicesDuplicated';

export default function Router() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
                <Route path="/recuperacao-de-acesso" element={<RegainAccessDocuments />} />
                <Route path='/recuperar-senha' element={<ForgotPassword />} />
                <Route path='/redefinir-senha/:code' element={<RecoveryPassword />} />
                <Route path="/termos-de-uso" element={<TermsOfUse />} />

                <Route element={<RequireAuthentication />}>
                    <Route path="/primeiro-acesso" element={<FirstAccess />} />

                    <Route element={<LayoutAdmin />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/inautorizado" element={<Unauthorized />} />
                        <Route path="/modulo-nao-encontrado" element={<CityHasNoModule />} />

                        <Route element={<RequireAuthorization allowedPermissions={['manage_county']} />}>
                            <Route path="/municipios" element={<Cities />} />
                            <Route path="/municipios/criar" element={<NewCity />} />
                            <Route path="/municipios/editar/:id" element={<EditCity />} />
                        </Route>

                        <Route element={<RequireAuthorization allowedPermissions={['manage_config']} />}>
                            <Route path="/configuracoes/perfis" element={<Roles />} />
                            <Route path="/configuracoes/perfis/criar" element={<NewRole />} />
                            <Route path="/configuracoes/perfis/editar/:id" element={<EditRole />} />

                            <Route path="/configuracoes/usuarios-painel" element={<PanelUsers />} />
                            <Route path="/configuracoes/usuarios-painel/criar" element={<NewPanelUser />} />
                            <Route path="/configuracoes/usuarios-painel/editar/:id" element={<EditPanelUser />} />

                            <Route path="/configuracoes/tipos-de-premios" element={<AwardTypes />} />
                            <Route path="/configuracoes/tipos-de-premios/criar" element={<NewAwardType />} />
                            <Route path="/configuracoes/tipos-de-premios/editar/:id" element={<EditAwardType />} />

                            <Route path="/configuracoes/assuntos-ajuda-e-suporte" element={<SubjectHelpAndSupport />} />
                            <Route path="/configuracoes/assuntos-ajuda-e-suporte/criar" element={<NewSubjectHelpAndSupport />} />
                            <Route path="/configuracoes/assuntos-ajuda-e-suporte/editar/:id" element={<EditSubjectHelpAndSupport />} />

                            <Route path='/codigo-acesso' element={<AccessCode />} />
                            <Route path='/configuracoes/logs' element={<AccessLogs />} />

                        </Route>

                        <Route element={<RequireAuthorization allowedPermissions={['manage_user_app']} />}>
                            <Route path="/usuarios/aplicativo" element={<AppUsers />} />
                            <Route path="/usuarios/aplicativo/visualizar/:id" element={<ViewAppUser />} />
                            <Route path="/usuarios/aplicativo/:id/bilhetes" element={<TicketsGroupedByGiveaway />} />
                            <Route path="/usuarios/aplicativo/:id/bilhetes/sorteio/:giveawayId" element={<AppUserTickets />} />

                            <Route path="/usuarios/auto" element={<AppUsersAuto />} />
                            <Route path="/usuarios/auto/:id" element={<ViewAppUserAuto />} />
                            <Route path="/usuarios/auto/:id/bilhetes" element={<ViewAppUserAuto defaultTab="bilhetes" />} />
                            <Route path="/usuarios/auto/:id/bilhetes/sorteio/:giveawayId" element={<ViewAppUserAuto defaultTab="bilhetes" />} />
                            <Route path="/usuarios/auto/:id/impostos" element={<ViewAppUserAuto defaultTab="impostos" />} />
                            <Route path="/usuarios/auto/visualizar/:id" element={<ViewAppUserAuto />} />


                            <Route element={<RequireModules allowedModules={[EModule.INVOICE_NFC, EModule.INVOICE_NFS]} />}>
                                <Route path="/usuarios/aplicativo/:id/notas" element={<InvoicesGroupedByMonth />} />
                                <Route path="/usuarios/aplicativo/:id/notas/:period" element={<Invoices />} />
                            </Route>

                            <Route element={<RequireModules allowedModules={[EModule.REWARD]} />}>
                                <Route path="/usuarios/aplicativo/:id/vouchers" element={<ViewAppUserVouchers />} />
                            </Route>

                            <Route element={<RecoverRequestsProvider />}>
                                <Route path="/recuperacao-acesso/" element={<RecoverRequests />} />
                                <Route path="/recuperacao-acesso/:id" element={<ViewRecoverRequest />} />
                            </Route>

                            <Route path="/ajuda-e-suporte" element={<HelpAndSupport />} />
                            <Route path="/ajuda-e-suporte/usuarios" element={<HelpAndSupport />} />
                            <Route path="/ajuda-e-suporte/usuarios/" element={<HelpAndSupport />} />
                            <Route path="/ajuda-e-suporte/usuarios/:id" element={<ViewMessageHelpAndSupport />} />

                            <Route path="/ajuda-e-suporte/externo/app" element={<HelpAndSupport />} />
                            <Route path="/ajuda-e-suporte/externo/site" element={<HelpAndSupport />} />
                            <Route path="/ajuda-e-suporte/externo/:id" element={<ViewMessageSupport />} />

                            <Route element={<RequireModules allowedModules={[EModule.INVOICE_NFS, EModule.INVOICE_NFC]} />}>
                                <Route path="/notas/geral" element={<CityInvoices />} />
                                <Route path="/notas/geral/importacao" element={<CityInvoicesImport />} />
                                <Route path="/notas/contingencia" element={<CityInvoicesAwaiting />} />
                                <Route path="/notas/duplicadas" element={<CityInvoicesDuplicated />} />
                                <Route path="/notas/estabelecimento" element={<CityCompanyInvoices />} />
                                <Route path="/notas/pendente" element={<CityPendingInvoices />} />
                                <Route path="/nota/detalhes/:id" element={<InvoiceDetails />} />
                            </Route>

                            <Route element={<RequireModules allowedModules={[EModule.SOCIAL_INSTITUTION]} />}>
                                <Route path="/instituicoes-sociais" element={<SocialInstitutions />} />
                            </Route>


                            <Route element={<RequireModules allowedModules={[EModule.TAXES]} />}>
                                <Route element={<CityTaxesProvider />}>
                                    <Route path="/impostos/municipais" element={<CityTaxes />} />
                                    <Route path="/impostos/municipais/:id" element={<ViewCityTax />} />
                                </Route>
                            </Route>

                            <Route element={<RequireModules allowedModules={[EModule.TAXES_AUTO]} />}>
                                <Route element={<CityTaxesAutoProvider />}>
                                    <Route path="/impostos/auto" element={<CityTaxesAuto />} />
                                    <Route path='/impostos/auto/importacao' element={<CityTaxeAutoImport />} />
                                </Route>
                            </Route>

                            <Route path="/mensagens" element={<Messages />} />
                            <Route path="/mensagens/criar" element={<NewMessage />} />
                            <Route path="/mensagens/editar/:id" element={<EditMessage />} />

                            <Route path='/avisos' element={<Notices />} />
                            <Route path='/avisos/criar' element={<NewNotice />} />
                            <Route path='/avisos/editar/:id' element={<EditNotice />} />
                        </Route>

                        <Route element={<RequireAuthorization allowedPermissions={['manage_raffle']} />}>
                            <Route path="/sorteios/geral" element={<Giveaways />} />
                            <Route path='/sorteios/geral/visualizar/:id' element={<ViewGiveaway />} />
                            <Route path="/sorteios/geral/criar" element={<NewGiveaway />} />
                            <Route path="/sorteios/geral/editar/:id" element={<EditGiveaway />} />
                            <Route path="/sorteios/geral/:id/bilhetes" element={<Tickets />} />

                            <Route path="/sorteios/geral/:id/ganhadores" element={<GiveawayWinners />} />
                            <Route path="/sorteios/geral/:id/participantes" element={<GiveawayParticipants />} />
                            <Route path="/sorteios/geral/:id/realizar-sorteio" element={<HoldGiveaway />} />
                            <Route path="/sorteios/geral/:id/processar-sorteio" element={<VerifyGiveaway />} />


                            <Route path="/sorteios/auto" element={<GiveawaysAuto />} />
                            <Route path="/sorteios/auto/criar" element={<NewGiveawayAuto />} />
                            <Route path="/sorteios/auto/editar/:id" element={<EditGiveawayAuto />} />
                            <Route path="/sorteios/auto/:id/bilhetes" element={<GiveawayTicketsAuto />} />

                            <Route path="/sorteios/auto/:id/ganhadores" element={<GiveawayAutoWinners />} />
                            <Route path="/sorteios/auto/:id/realizar-sorteio" element={<HoldGiveawayAuto />} />
                            <Route path="/sorteios/auto/:id/processar-sorteio" element={<VerifyGiveawayAuto />} />
                            <Route path='/sorteios/auto/visualizar/:id' element={<ViewGiveawayAuto />} />
                        </Route>

                        <Route element={<RequireAuthorization allowedPermissions={['manage_reward']} />}>
                            <Route element={<RequireModules allowedModules={[EModule.REWARD]} />}>
                                <Route path="/recompensas" element={<Rewards />} />
                                <Route path="/recompensas/criar" element={<NewReward />} />
                                <Route path="/recompensas/editar/:id" element={<EditReward />} />

                                <Route path="/categorias" element={<Categories />} />
                                <Route path="/categorias/criar" element={<NewCategory />} />
                                <Route path="/categorias/editar/:id" element={<EditCategory />} />

                                <Route path="/vouchers" element={<Vouchers />} />
                                <Route path="/vouchers/:code" element={<ViewVoucher />} />
                            </Route>
                        </Route>
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    )
}
